<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="1200px"
    top="5vh"
    append-to-body
    custom-class="lam-dialog"
    :close-on-click-modal="false"
    @close="handleClose">
    <div class="lam-layout" :class="{ 'lam-layout--teacher': personType === 'teacher' }">
      <div v-if="personType === 'student'" class="lam-left">
        <DepartmentPane directory-scope="teaching"
          :type="departmentPaneType"
          @tree-node-click="onTreeNodeClick">
        </DepartmentPane>
      </div>
      <div class="lam-right">
        <div class="toolbar-filter-bar toolbar-filter-bar--embed">
          <el-form :inline="true" class="toolbar-filter-form" @submit.native.prevent="loadPreview(1)">
            <div class="toolbar-filter-fields">
              <el-form-item>
                <el-input
                  v-model="nameKeyword"
                  clearable
                  :placeholder="personType === 'student' ? '姓名' : '教师姓名'"
                  class="toolbar-field-w-md"
                  @keyup.enter.native="loadPreview(1)">
                </el-input>
              </el-form-item>
              <el-form-item v-if="personType === 'student'">
                <el-input
                  v-model="cardNoKeyword"
                  clearable
                  placeholder="卡号"
                  class="toolbar-field-w-md"
                  @keyup.enter.native="loadPreview(1)">
                </el-input>
              </el-form-item>
              <el-form-item v-if="personType === 'teacher'">
                <el-select
                  v-model="campusId"
                  clearable
                  filterable
                  placeholder="关联校区"
                  class="toolbar-field-w-md"
                  @change="loadPreview(1)">
                  <el-option
                    v-for="item in campusOptions"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" icon="el-icon-search" :loading="listLoading" @click="loadPreview(1)">查询</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <div class="lam-hint" v-if="departmentName">
          <template v-if="personType === 'teacher'">
            当前学校：<strong>{{ departmentName }}</strong>
            <template v-if="selectedCampusLabel">
              <span class="lam-hint-sep">·</span>
              校区：<strong>{{ selectedCampusLabel }}</strong>
            </template>
            <span class="lam-hint-sub">（仅显示头像仍存本机 /userLogo 路径的教师）</span>
          </template>
          <template v-else>
            当前部门：<strong>{{ departmentName }}</strong>
            <span class="lam-hint-sub">（仅显示含本机 /userLogo 路径的人员）</span>
          </template>
        </div>
        <div class="lam-hint lam-hint--warn" v-else>
          {{ personType === 'teacher' ? '未获取到学校，请先在顶栏选择学校' : '请先在左侧选择部门' }}
        </div>

        <div class="lam-table-wrap" ref="migrateTableWrap">
          <el-table
            ref="migrateTable"
            :data="rows"
            v-loading="listLoading"
            :height="tableBodyHeight"
            size="small"
            stripe
            highlight-current-row
            @row-click="onRowClick"
            @selection-change="onSelectionChange">
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column label="头像" width="72">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.PreviewUrl"
                  :src="scope.row.PreviewUrl"
                  fit="cover"
                  class="lam-avatar"
                  :preview-src-list="[scope.row.PreviewUrl]">
                </el-image>
                <span v-else class="lam-no-photo">无</span>
              </template>
            </el-table-column>
            <el-table-column prop="Name" :label="personType === 'student' ? '姓名' : '教师'" min-width="90" show-overflow-tooltip></el-table-column>
            <el-table-column prop="DepartmentName" label="部门" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="HeadPhotoImage" label="当前路径" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.MigrateStatus === 'ready'" type="success" size="mini">可迁移</el-tag>
                <el-tag v-else type="warning" size="mini">文件缺失</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-pagination
          class="lam-pagination"
          layout="total, prev, pager, next, jumper"
          :current-page.sync="page"
          :page-size="pageSize"
          :total="total"
          @current-change="loadPreview">
        </el-pagination>

        <div class="lam-actions">
          <el-button
            type="primary"
            size="small"
            :loading="migrating"
            :disabled="!departmentId || selectedRows.length === 0"
            @click="executeMigrate(false)">
            迁移选中（{{ selectedRows.length }}）
          </el-button>
          <el-button
            type="warning"
            size="small"
            :loading="migrating"
            :disabled="!departmentId"
            @click="executeMigrate(true)">
            {{ personType === 'teacher' ? (campusId ? '迁移本校区全部' : '迁移本校全部') : '迁移本部门全部' }}
          </el-button>
        </div>

        <div v-if="migrating" class="lam-progress">
          <i class="el-icon-loading"></i>
          <span>{{ migrateProgressText }}</span>
        </div>

        <el-alert
          v-if="executeSummary"
          :title="executeSummary"
          type="info"
          :closable="false"
          show-icon
          class="lam-summary">
        </el-alert>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import DepartmentPane from './DepartmentPane'
import { previewStudentLocalAvatarMigrate, executeStudentLocalAvatarMigrate, previewTeacherLocalAvatarMigrate, executeTeacherLocalAvatarMigrate } from '../api/modules/personnel';
import { getCampusList } from '../api/modules/misc';
export default {
  name: 'LocalAvatarMigrateDialog',
  components: { DepartmentPane },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    personType: {
      type: String,
      default: 'student'
    },
    /** 教师模式：传入当前学校部门 Id（顶栏 activeSchoolId） */
    schoolDepartmentId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      departmentId: '',
      departmentName: '',
      nameKeyword: '',
      cardNoKeyword: '',
      rows: [],
      selectedRows: [],
      listLoading: false,
      migrating: false,
      migrateProgressText: '正在迁移，请勿关闭…',
      executeSummary: '',
      page: 1,
      total: 0,
      campusId: null,
      campusOptions: [],
      tableBodyHeight: 400
    }
  },
  computed: {
    /** 弹窗内表格：教师 10 条/页，学生 20 条/页 */
    pageSize() {
      return this.personType === 'teacher' ? 10 : 20
    },
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    dialogTitle() {
      return this.personType === 'student' ? '学生头像迁移至 OSS' : '教师头像迁移至 OSS'
    },
    departmentPaneType() {
      return this.personType === 'teacher' ? 1 : 0
    },
    selectedCampusLabel() {
      if (!this.campusId) return ''
      const item = (this.campusOptions || []).find((c) => c.Id === this.campusId)
      return item ? item.Name : ''
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.resetState()
        if (this.personType === 'teacher') {
          this.initTeacherSchoolScope()
        }
        this.$nextTick(() => this.syncTableHeight())
      } else {
        this.unbindTableResize()
      }
    }
  },
  beforeDestroy() {
    this.unbindTableResize()
  },
  methods: {
    resetState() {
      this.executeSummary = ''
      this.migrating = false
      this.selectedRows = []
      this.rows = []
      this.page = 1
      this.total = 0
      this.nameKeyword = ''
      this.cardNoKeyword = ''
      this.campusId = null
      this.campusOptions = []
      this.tableBodyHeight = 400
      if (this.personType !== 'teacher') {
        this.departmentId = ''
        this.departmentName = ''
      }
    },
    initTeacherSchoolScope() {
      const id = this.schoolDepartmentId
        || this.$store.state.activeSchoolId
        || window.localStorage.getItem('activeSchoolId')
      if (!id) {
        this.departmentId = ''
        this.departmentName = ''
        this.rows = []
        this.total = 0
        return
      }
      this.departmentId = String(id)
      this.departmentName = this.$store.state.activeSchoolName
        || window.localStorage.getItem('activeSchoolName')
        || '当前学校'
      this.page = 1
      this.loadTeacherCampusOptions().then(() => this.loadPreview(1))
    },
    async loadTeacherCampusOptions() {
      if (!this.departmentId) {
        this.campusOptions = []
        this.campusId = null
        return
      }
      try {
        const res = await getCampusList({
          page: 1,
          intPageSize: 999,
          departmentId: this.departmentId
        })
        if (res.data.success) {
          this.campusOptions = res.data.response.data || []
        } else {
          this.campusOptions = []
        }
      } catch (e) {
        this.campusOptions = []
      }
    },
    handleClose() {
      this.unbindTableResize()
      this.resetState()
    },
    /** 表格高度随可用区域自适应。最后更新：2026-09-15 */
    syncTableHeight() {
      const measure = () => {
        const wrap = this.$refs.migrateTableWrap
        if (!wrap) return
        const h = Math.floor(wrap.clientHeight)
        if (h > 120 && h !== this.tableBodyHeight) {
          this.tableBodyHeight = h
          this.$nextTick(() => {
            if (this.$refs.migrateTable && this.$refs.migrateTable.doLayout) {
              this.$refs.migrateTable.doLayout()
            }
          })
        }
      }
      this.$nextTick(() => {
        measure()
        setTimeout(measure, 60)
      })
      this.bindTableResize()
    },
    bindTableResize() {
      if (this._lamResizeBound) return
      this._lamOnResize = () => this.syncTableHeight()
      window.addEventListener('resize', this._lamOnResize)
      this._lamResizeBound = true
    },
    unbindTableResize() {
      if (this._lamOnResize) {
        window.removeEventListener('resize', this._lamOnResize)
        this._lamOnResize = null
      }
      this._lamResizeBound = false
    },
    onTreeNodeClick(data) {
      this.departmentId = data.value
      this.departmentName = data.label || data.name || ''
      this.page = 1
      this.loadPreview(1)
    },
    async loadPreview(page) {
      if (!this.departmentId) {
        this.rows = []
        this.total = 0
        return
      }
      this.page = page || this.page
      this.listLoading = true
      try {
        const params = {
          departmentId: String(this.departmentId),
          page: this.page,
          intPageSize: this.pageSize
        }
        if (this.personType === 'student') {
          params.stuName = (this.nameKeyword || '').trim()
          params.cardNo = (this.cardNoKeyword || '').trim()
        } else {
          params.teacherName = (this.nameKeyword || '').trim()
          if (this.campusId) {
            params.campusId = this.campusId
          }
        }

        const request = this.personType === 'student'
          ? previewStudentLocalAvatarMigrate
          : previewTeacherLocalAvatarMigrate
        const res = await request(params)
        if (!res.data.success) {
          this.$message.error(res.data.msg || '加载失败')
          return
        }
        const pageData = res.data.response || {}
        this.rows = pageData.data || []
        this.total = pageData.dataCount || 0
        this.$nextTick(() => {
          this.syncTableHeight()
          this.autoSelectReadyRows()
        })
      } catch (e) {
        this.$message.error('加载待迁移列表失败')
      } finally {
        this.listLoading = false
      }
    },
    autoSelectReadyRows() {
      const table = this.$refs.migrateTable
      if (!table) return
      table.clearSelection()
      this.rows.forEach(row => {
        if (row.MigrateStatus === 'ready') {
          table.toggleRowSelection(row, true)
        }
      })
    },
    /** 点击行切换勾选（跳过复选框与头像预览）。最后更新：2026-09-15 */
    onRowClick(row, column, event) {
      if (!row) return
      if (event && event.target) {
        const target = event.target
        if (
          target.classList.contains('el-checkbox__original') ||
          target.classList.contains('el-checkbox__inner') ||
          (target.closest && (target.closest('.el-checkbox') || target.closest('.el-image') || target.closest('.el-image-viewer__wrapper')))
        ) {
          return
        }
      }
      const table = this.$refs.migrateTable
      if (!table) return
      table.toggleRowSelection(row)
    },
    onSelectionChange(val) {
      this.selectedRows = val || []
    },
    async executeMigrate(migrateAllDept) {
      if (!this.departmentId) {
        this.$message.warning(this.personType === 'teacher' ? '请先在顶栏选择学校' : '请先在左侧选择部门')
        return
      }
      if (!migrateAllDept && this.selectedRows.length === 0) {
        this.$message.warning('请勾选待迁移人员')
        return
      }

      const readyCount = migrateAllDept
        ? this.total
        : this.selectedRows.filter(r => r.MigrateStatus === 'ready').length
      const tip = migrateAllDept
        ? (this.personType === 'teacher'
          ? (this.campusId
            ? `确认迁移当前校区（${this.selectedCampusLabel || '已选校区'}）下全部待迁移教师（约 ${this.total} 人）？上传成功后将删除本机图片。`
            : `确认迁移当前学校下全部待迁移教师（约 ${this.total} 人）？上传成功后将删除本机图片。`)
          : `确认迁移当前部门下全部待迁移人员（约 ${this.total} 人）？上传成功后将删除本机图片。`)
        : `确认迁移选中的 ${readyCount} 人？上传成功后将删除本机图片。`

      try {
        await this.$confirm(tip, '确认迁移', { type: 'warning' })
      } catch (e) {
        return
      }

      this.migrating = true
      this.executeSummary = ''
      this.migrateProgressText = '正在上传至 OSS，请稍候…'

      const payload = {
        DepartmentId: String(this.departmentId),
        Ids: migrateAllDept ? [] : this.selectedRows.map(r => r.Id)
      }
      if (this.personType === 'teacher' && this.campusId) {
        payload.CampusId = this.campusId
      }

      try {
        const request = this.personType === 'student'
          ? executeStudentLocalAvatarMigrate
          : executeTeacherLocalAvatarMigrate
        const res = await request(payload)
        if (!res.data.success) {
          this.$message.error(res.data.msg || '迁移失败')
          return
        }
        const result = res.data.response || {}
        const successCount = result.SuccessCount || 0
        const skipCount = result.SkipCount || 0
        const failCount = result.FailCount || 0
        this.executeSummary = `完成：成功 ${successCount}，跳过 ${skipCount}，失败 ${failCount}`
        if (failCount > 0) {
          this.$message.warning(this.executeSummary)
        } else {
          this.$message.success(this.executeSummary)
        }
        this.$emit('done')
        await this.loadPreview(this.page)
      } catch (e) {
        this.$message.error('迁移请求失败，请稍后重试')
      } finally {
        this.migrating = false
      }
    }
  }
}
</script>

<style scoped>
.lam-layout {
  display: flex;
  gap: 12px;
  height: 640px;
  max-height: calc(90vh - 140px);
  min-height: 420px;
}
.lam-layout--teacher {
  height: 640px;
  max-height: calc(90vh - 140px);
  min-height: 420px;
}
.lam-layout--teacher .lam-right {
  width: 100%;
}
.lam-left {
  width: 320px;
  flex-shrink: 0;
  border-right: 1px solid #ebeef5;
  padding-right: 8px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
.lam-left >>> .department-pane {
  flex: 1;
  min-height: 0;
  height: 100% !important;
  overflow: hidden !important;
}
.lam-left >>> .pane-content-wrapper {
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.lam-left >>> .department-pane .el-tree,
.lam-left >>> .department-pane .flow-tree {
  flex: 1 1 0 !important;
  min-height: 0 !important;
  height: 0 !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}
.lam-left >>> .toggle-tree-bar,
.lam-left >>> .pane-collapse-btn,
.lam-left >>> .pane-expand-btn,
.lam-left >>> .pane-expand-tab {
  display: none;
}
.lam-right {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.lam-right > .toolbar-filter-bar {
  flex-shrink: 0;
}
.lam-table-wrap {
  flex: 1 1 0;
  min-height: 0;
  height: 0;
  overflow: hidden;
}
.lam-table-wrap >>> .el-table__row {
  cursor: pointer;
}
.lam-hint-sep {
  margin: 0 4px;
  color: #cbd5e1;
}
.lam-hint {
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.lam-hint-sub {
  color: #909399;
  margin-left: 4px;
}
.lam-hint--warn {
  color: #e6a23c;
}
.lam-avatar {
  width: 48px;
  height: 48px;
  border-radius: 4px;
}
.lam-no-photo {
  color: #c0c4cc;
  font-size: 12px;
}
.lam-pagination {
  margin-top: 8px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.lam-actions {
  margin-top: 12px;
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.lam-progress {
  margin-top: 10px;
  color: var(--btn-primary, #2563eb);
  font-size: 13px;
}
.lam-summary {
  margin-top: 10px;
}
</style>

<style>
/* 弹窗内部门树需固定高度才能滚动；取消全局 body 限高。最后修改：2026-09-14 */
.lam-dialog .el-dialog__body {
  max-height: none !important;
  padding-top: 12px;
  padding-bottom: 12px;
  overflow: hidden;
}
</style>
